<template>
  <woot-modal :show.sync="show" :on-close="onClose" size="modal-fit">
    <div class="plan-limit-modal">
      <div class="plan-limit-modal__icon-wrap">
        <fluent-icon icon="lock-closed" size="28" />
      </div>
      <div class="plan-limit-modal__body">
        <p
          v-for="(paragraph, index) in paragraphs"
          :key="index"
          class="plan-limit-modal__paragraph"
        >
          {{ paragraph }}
        </p>
        <a
          class="plan-limit-modal__cta"
          :href="commercialWhatsappUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <fluent-icon icon="chat" size="18" />
          {{ linkText }}
        </a>
      </div>
    </div>
  </woot-modal>
</template>

<script>
import configMixin from 'shared/mixins/configMixin';

export default {
  mixins: [configMixin],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    description: {
      type: [String, Array],
      default: '',
    },
    linkText: {
      type: String,
      default: 'Clique aqui e fale com a gente.',
    },
  },
  computed: {
    paragraphs() {
      if (Array.isArray(this.description)) return this.description;
      return this.description.split('\n').filter(p => p.trim() !== '');
    },
  },
};
</script>

<style lang="scss" scoped>
.plan-limit-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 40px 40px;
  max-width: 680px;
  width: 100%;

  &__icon-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background-color: #e8f0fe;
    color: #3b6ecc;
    margin-bottom: 24px;
    flex-shrink: 0;
  }

  &__body {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  &__paragraph {
    font-size: var(--font-size-default, 1.4rem);
    color: var(--s-700, #374151);
    line-height: 1.6;
    margin: 0 0 20px;
    text-align: left;

    &:last-of-type {
      margin-bottom: 20px;
    }
  }

  &__cta {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #3b6ecc;
    font-size: var(--font-size-default, 1.4rem);
    font-weight: var(--font-weight-medium, 500);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
      color: #2a55a8;
    }
  }
}
</style>
